// @core/api/endpoints/userprofile/get_userprofile_default_id.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserprofileDefaultIDResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get default profile ID for user
 * Returns only the ID of the default profile without full profile data. Lightweight alternative when only the identifier is needed.
 */
export async function GetUserprofileDefaultID(
  user_id: string,
  options?: RequestOptions
): Promise<GetUserprofileDefaultIDResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/user/:user_id/default/id`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<GetUserprofileDefaultIDResponse>(requestPath, { ...requestOptions });
}
